import { Text } from 'platform-components';
import React from 'react';

import './promo__description.scss';

interface Props {
    description: string;
}

const PromoDescription = ({ description }: Props) =>
    description ? (
        <div className="promo__description">
            <Text type={Text.TYPE.MARKDOWN}>{description}</Text>
        </div>
    ) : null;

export default React.memo(PromoDescription);
